import { ReactComponentManifest } from "web/entrypoints/common/setup";
import Footer from "web/react/components/footer/footer";
import HomepageLayout from "web/react/components/homepage-layout/homepage-layout";

const components: ReactComponentManifest = {
    Footer,
    HomepageLayout,
};

export default components;
